import { jsx as _jsx } from "react/jsx-runtime";
import { Badge, useLocalizeMessage } from 'libs.nucleus';
import { useDateTime } from 'libs.react';
export const VisitStatusBadge = ({ visitEvent }) => {
    const translate = useLocalizeMessage();
    const dateFormatter = useDateTime();
    switch (true) {
        case !!visitEvent?.c_started:
            return _jsx(Badge, { label: dateFormatter.parseDateShort(visitEvent?.c_started) });
        case !!visitEvent?.c_skipped_date:
            return (_jsx(Badge, { variant: 'incomplete', label: `${translate('generic.skipped')} - ${dateFormatter.parseDateShort(visitEvent?.c_skipped_date)}` }));
        default:
            return null;
    }
};
